import { render, staticRenderFns } from "./addEntity.vue?vue&type=template&id=044c1420&scoped=true&"
import script from "./addEntity.vue?vue&type=script&lang=js&"
export * from "./addEntity.vue?vue&type=script&lang=js&"
import style0 from "./addEntity.vue?vue&type=style&index=0&id=044c1420&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c1420",
  null
  
)

export default component.exports